import React, { useMemo } from 'react'
import { Box } from '@mui/material'
import { useLegalBases } from 'api/legalBases/queries/useLegalBases'
import { usePolicyScopes } from 'api/policyScopes/queries/usePolicyScopes'
import { RoutesManager } from 'utils/routing/routesManager'
import { getValidPolicyScopesForPurpose } from 'pages/policyCenter/purposes/utils'
import { NavigationBreadCrumbs } from 'components/appLayout/appNavigation/breadcrumbs/NavigationBreadCrumbs'
import { ContentGroup, DataGrid } from '@ketch-com/deck'
import { legalBasisGridColumns } from './utils/purposesTabLegalBasisUtils'
import { usePurposeViewContext } from 'pages/policyCenter/purposes/view/context/PurposeViewContext'

export const PurposesTabLegalBasis: React.FC = () => {
  const { purpose } = usePurposeViewContext()
  const { data: legalBases, isLoading: isLegalBasesLoading } = useLegalBases()
  const { data: policyScopes, isLoading: isPolicyScopesLoading } = usePolicyScopes()

  const validPolicyScopesForPurpose = useMemo(
    () => getValidPolicyScopesForPurpose({ policyScopes, legalBases }),
    [policyScopes, legalBases],
  )

  const isTableDataLoading = isLegalBasesLoading || isPolicyScopesLoading || !validPolicyScopesForPurpose.length

  return (
    <>
      <NavigationBreadCrumbs
        type="dark"
        items={[
          { title: 'Privacy Program', link: RoutesManager.policyCenter.root.getURL() },
          { title: 'Purposes', link: RoutesManager.policyCenter.purposes.root.getURL() },
          {
            title: purpose?.name || purpose?.code,
            link: RoutesManager.policyCenter.purposes.view.root.getURL({ code: purpose?.code || '' }),
          },
          { title: 'Legal Basis Assignment' },
        ]}
      />

      <Box display="flex" flexDirection="column" gap={4} mb={6}>
        <ContentGroup title="Legal Bases" titleVariant="h3" variant="inner-page-header" />
        {purpose && (
          <DataGrid
            sx={{
              padding: 'unset',
              height: 'auto',
              '& .MuiDataGrid-virtualScrollerContent': {
                height: isTableDataLoading ? '300px !important' : 'auto',
              },
            }}
            autosizeOnMount
            columns={legalBasisGridColumns(purpose, legalBases)}
            disableChildrenSorting
            disableColumnMenu
            disableColumnPinning
            disableColumnReorder
            disableColumnResize
            disableRowHoverStates
            disableRowSelectionOnClick
            loading={isTableDataLoading}
            getRowId={row => row.code}
            hideFooter
            rows={validPolicyScopesForPurpose}
            getRowHeight={() => 'auto'}
          />
        )}
      </Box>
    </>
  )
}
